import { DbRecording } from "./EvidenceDB/DatabaseTypes";

export const verifyFileSystemPermission = async (fsd: FileSystemHandle = new FileSystemHandle()) => {
	if ((await fsd.queryPermission({ mode: 'readwrite' })) !== 'granted') {
		if (await fsd.requestPermission({ mode: 'readwrite' }) !== 'granted') {
			return false;
		}
	}
	return true;
};

export const getUserChosenDirectoryHandle = async ({
	mode='readwrite',
	...options}: Parameters<typeof window.showDirectoryPicker>[0] = {}) => {
	try {
		return await window.showDirectoryPicker({ ...options, mode});
	} catch (e) {
		if (e instanceof DOMException && e.name === 'AbortError') {
			return;
		}
		throw e;
	}
};

export const getRecordingName = (recording: DbRecording) => {
	if (recording.name != null && recording.name.length > 0) {
		return recording.name;
	} else {
		return `Recording Started ${(new Date(recording.startTimeIso).toLocaleString())}`;
	}
};
